'use strict';

var Day = require('./Day');
var DayFromYear = require('./DayFromYear');
var YearFromTime = require('./YearFromTime');

// https://262.ecma-international.org/5.1/#sec-15.9.1.4

module.exports = function DayWithinYear(t) {
	return Day(t) - DayFromYear(YearFromTime(t));
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/DayWithinYear.js
// module id = 339
// module chunks = 0